import { apiCall, API } from '../../utils/APIFunctions';

export function fetchUserDocumentStatistics() {
  return apiCall(`${API}/stats/user_documents`, "GET");
}